export enum TRIGGER_TYPE {
  WORKFLOW = 'workflow',
  WEBHOOK = 'webhook',
}

export enum TRIGGER_SOURCE {
  NOTEBOOK = 'notebook',
  REPORT = 'report',
}
